import {getGroupNumberFromOrganisation, getVATIdentificationNumberFromOrganisation} from 'front-onceforall-core/dist/utils/organisations';
import config from '../../../config';
import {authFetch, checkStatus, checkStatusExceptNotFound} from '../../utils/http';

const SUBSCRIPTION_API = `${config.subscriptionApi}/api/v1/subscriptions`;
const PLANS_API = `${config.subscriptionApi}/api/v1/plans`;

export default class LiveSubscriptionService {
  subscriptionExistsByExternalOrganisation(organisation) {
    const groupNumber = getGroupNumberFromOrganisation(organisation);
    const vatIdentificationNumber = getVATIdentificationNumberFromOrganisation(organisation);

    let url = `${SUBSCRIPTION_API}/organisations/exists` +
      `?country=${organisation.country}` +
      `&registrationNumber=${organisation.registrationNumber}`;
    if (groupNumber) {
      url = `${url}&groupNumber=${groupNumber}`;
    }

    if (vatIdentificationNumber) {
      url = `${url}&vatIdentificationNumber=${vatIdentificationNumber}`;
    }

    return authFetch(url)
      .then(checkStatus)
      .then(() => true)
      .catch(() => false);
  }

  findSubscriptionByOrganisation(organisationId, signal) {
    return authFetch(`${SUBSCRIPTION_API}/organisations/${organisationId}`, {signal})
      .then(checkStatusExceptNotFound);
  }

  /**
   * Get plans on ChargeBee (via Link)
   * @param {string} organisationId - organisation identifier in OFA
   */
  getSuggestedPlans(organisationId, answers = {}) {
    return authFetch(
      `${PLANS_API}/organisations/${organisationId}/suggested-plans?shareCompliance=${answers.shareCompliance}&nbOfClients=${answers.nbOfClients}`
    )
      .then(checkStatusExceptNotFound);
  }

  /**
   * Get current organisation plan on ChargeBee (via Link)
   * @param {string} organisationId - organisation identifier in OFA
   */
  getOrganisationPlan(organisationId, signal) {
    return authFetch(
      `${PLANS_API}/organisations/${organisationId}`,
      {signal}
    )
      .then(checkStatusExceptNotFound);
  }

  subscribeToPlan(organisationId, plan) {
    return authFetch(`${PLANS_API}/organisations/${organisationId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(plan)
    });
  }

  upgradeToPlan(organisationId, plan) {
    return authFetch(`${PLANS_API}/organisations/${organisationId}/upgrade`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(plan)
    });
  }

  getInvoicesByOrganisation(organisationId, offset = null, size = 10) {
    let url = `${SUBSCRIPTION_API}/organisations/${organisationId}/invoices?limit=${size}`;
    if (offset) {
      url += `&offset=${offset}`;
    }

    return authFetch(url)
      .then(checkStatus)
      .then(response => response.json());
  }

  getInvoiceUrl(organisationId, invoiceId) {
    return `${SUBSCRIPTION_API}/organisations/${organisationId}/invoices/${invoiceId}`;
  }

  getNumberOfActiveClients(organisationId) {
    return authFetch(
      `${SUBSCRIPTION_API}/organisations/${organisationId}/count/distinct-active-client-customers`
    )
      .then(checkStatus)
      .then(response => response.json());
  }
}
